import { render } from "./CreatedTraining.vue?vue&type=template&id=123b3daa&scoped=true"
import script from "./CreatedTraining.vue?vue&type=script&lang=js"
export * from "./CreatedTraining.vue?vue&type=script&lang=js"

import "./CreatedTraining.vue?vue&type=style&index=0&id=123b3daa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123b3daa"]])

export default __exports__